import React from 'react';

function Form7() {
  return (
    <div>
      <h2>Form7</h2>
    </div>
  );
}

export default Form7;
